// Configuración general para tokens

export const defaultPermissions = {
  clientes: { read: false, create: false, update: false, delete: false },
  agendamientoPrevicar: { read: false, create: false, update: false, delete: false },
  pagos: { read: false, create: false, update: false, delete: false },
  bro: { read: false, create: false, update: false, delete: false },
  ViaRapida: { read: false, create: false, update: false, delete: false },
  PeritoVML: { read: false, create: false, update: false, delete: false },
};

export const serviceLabels = {
  clientes: 'Clientes',
  agendamientoPrevicar: 'Agendamiento Previcar',
  pagos: 'Pagos',
  bro: 'BRO',
  ViaRapida: 'BRO-ViaRapida',
  PeritoVML: 'PeritoVML',
};

export const expirationOptions = [
  { value: '1h', label: '1 hora' },
  { value: '24h', label: '24 horas' },
  { value: '7d', label: '7 días' },
  { value: '30d', label: '30 días' },
  { value: '365d', label: '1 año' },
  { value: 'nunca', label: 'Sin expiración' }
]; 